import Vue from 'vue'
/* eslint-disable no-unused-vars */
import {
  Validator, /* NÃO RETIRAR ESSA IMPORTAÇÃO */
  extend,
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate'
/* eslint-enable no-unused-vars */
import {
  email,
  max,
  min,
  min_value,
  numeric,
  required,
  excluded,
  between
} from 'vee-validate/dist/rules'
import dayjs from 'dayjs';

extend('email', {
  ...email,
  message: 'Formato de e-mail inválido'
});

extend('max', {
  ...max,
  message: 'O valor do campo está inválido'
});

extend('between', {
  ...between,
  message: 'O valor campo está fora do que é permitido'
});

extend('min', {
  ...min,
  message: 'O valor do campo está inválido'
});

extend('min_value', {
  ...min_value,
  message: 'O valor do campo está inválido'
});

extend('numeric', {
  ...numeric,
  message: 'Valor inválido'
});

extend('required', {
  ...required,
  message: 'Este campo é obrigatório'
});

extend('required_if', {
  ...required,
  message: 'Este campo é obrigatório'
});

extend('excluded', {
  ...excluded,
  message: 'Valor inválido'
});

extend('uniqueMapeamento', {
  validate: (value, values) => {
    let count = 0;
    values.forEach(v => {
      if (v == value) count++;
    });

    return count > 1 ? false : true;
  },
  message: 'Campo já mapeado'
});

extend('min_value', {
  ...min_value,
  message: 'O valor do campo está inválido'
});

extend('positive', {
  validate: (value) => {
    return value >= 0;
  },
  message: 'O valor deve ser um número positivo.',
});


extend('integer', {
  validate: (value) => {
    return !isNaN(value) && Number.isInteger(parseFloat(value));
  },
  message: 'Apenas números inteiros são aceitos'
});

extend('medium_number_percent', {
  validate: (value) => {
    return (value >= 0 && value <= 100) ? true : false;
  },
  message: 'Apenas valores entre 0 (0%) e 100 (100%) são aceitos'
});

extend('forcar_erro', {
  validate: (value, args) => {
    return args ? args[0] : 'Valor incorreto';
  },
  message: 'Valor incorreto'
});

extend('date_precisa_ser_menor_ou_igual_a', {
  validate: (value, args) => {
    const [dataParaComparacao, mensagemErroCustomizada] = args;

    const valueInput = value && value.length == 10 ? parseDate(value) : null;

    /* Como a data para comparação é invalida é retornado TRUE */
    if (!dataParaComparacao || dataParaComparacao.length < 10 || !valueInput) return true;

    if (dayjs(valueInput) > dayjs(dataParaComparacao)) {
      return mensagemErroCustomizada || false;
    }

    return true;
  },
  message: 'Range de data inválido'
});

extend('date_precisa_ser_maior_ou_igual_a', {
  validate: (value, args) => {
    const [dataParaComparacao, mensagemErroCustomizada] = args;

    const valueInput = value && value.length == 10 ? parseDate(value) : null;

    /* Como a data para comparação é invalida é retornado TRUE */
    if (!dataParaComparacao || dataParaComparacao.length < 10 || !valueInput) return true;

    if (dayjs(valueInput) < dayjs(dataParaComparacao)) {
      return mensagemErroCustomizada || false;
    }

    return true;
  },
  message: 'Range de data inválido'
});

extend('unique_values', {
  validate: (value, {array_values}) => {
    const arrayValues = JSON.parse(array_values);
    if (!arrayValues) return false;

    let retorno = true;

    let count = 0;
    arrayValues.forEach(item => {
      if(item && item.trim() === value && value.trim()) count++;
    });
    if (count > 1) retorno = false;

    return retorno;
  },
  params: ['array_values'],
  message: 'Valor duplicado'
});

extend('data_vigencia_wacc_check', {
  validate: (value, {versao_submodulo, sub_modulos}) => {
    const submodulos = JSON.parse(sub_modulos);
    if (!submodulos) return false;

    let retorno = true;
    const submodulosDESC = submodulos.reverse();
    const posicaoUltimoElemento = submodulosDESC.length - 1;
    
    submodulosDESC.forEach((val, key) => {
      if(
        val.versao_submodulo !== versao_submodulo || /* Valida somente o modulo atual */
        ![val.data_inicio_vigencia, val.data_fim_vigencia].includes(parseDate(value)) || /* Valida somente a vigencia atual */
        posicaoUltimoElemento === key /* O utlimo elemento não precisa ser validado */
      ) {
        return 'continue';
      }

      // let inicioVigencia = dayjs(val.data_inicio_vigencia);
      let fimVigencia = dayjs(val.data_fim_vigencia);
      let inicioVigenciaExistenteProximoElemento = dayjs((submodulosDESC[key +1])?.data_inicio_vigencia);
      let inicioVigenciaEsperadoProximoElemento = fimVigencia.add(1, 'day');

      if (inicioVigenciaExistenteProximoElemento) {
        /* Verifica se a "Data de Inicio da Vigência Existente No Proximo Elemento" é diferente da "Data de Inicio da Vigência Esperado No Proximo Elemento"" */
        if (!inicioVigenciaExistenteProximoElemento.isSame(inicioVigenciaEsperadoProximoElemento) ) {
          retorno = 'Vigência inválida';
        }
      }
    });

    return retorno;
  },
  params: ['versao_submodulo', 'sub_modulos'],
  message: 'Valor invalido'
});

function parseDate(date) {
  if (!date || date.length < 10) return null

  const [day, month, year] = date.split('/');
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
}

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)